<template>
   <header>
       <div class="header" :style="{backgroundImage:'url('+multimediaInformation.location+')'}" >

           <div class="fixTop">
               <div class="onlynav FontColorWhite" id="navbar-example">
                   <i class="iconfont icon-EI-logo-copy nav-icon"></i>
                   <ul  class="nav nav-tabs" role="tablist" id="ulNode">

                       <li v-for="(item,index) in menuData.slice(0,5)" :key="item.itemId" v-if="item.itemName" >

                           <a v-if="index < 4" v-bind:href="menuScrollId[index]" v-on:click.prevent="aboutUs(index,menuScrollId[index])">{{item.itemName}}</a>
                           <a v-else="index >=4 " v-bind:href="item.url" target="_blank">{{item.itemName}}</a>
                       </li>

                       <!--<li ><a href="#introduceRoom" >产品介绍</a></li>-->
                       <!--<li ><a href="#advantageRoom">产品优势</a></li>-->
                       <!--<li ><a href="#updateRoom">版本更新</a></li>-->
                       <!--<li ><a href="#contactRoom">联系我们</a></li>-->
                       <!--<li ><a href="#aboutRoom">关于臻创</a></li>-->
                   </ul>

               </div>
           </div>

       </div>

   </header>
</template>

<script>
    export default {
        name: "Header",
        data(){
           return{

               // menuScrollId:['#introduceRoom','#advantageRoom','#updateRoom','#contactRoom','#aboutRoom'],
               menuScrollId:['#introduceRoom','#advantageRoom','#updateRoom','#contactRoom','#aboutRoom'],
               menuData: [],

               multimediaInformation:{},
           }
        },
        created(){
            this.$GetMenuData().then(() => {
                const { items=[] } = this.$store.state.menuData
                this.menuData = items
            });

            this.$GetMultimediaData( {locationId: 1} ).then(() => {
                const { multimediaInformation=[] }= this.$store.state.multimediaData;
                this.multimediaInformation = multimediaInformation;
            })




        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll)
        },
        methods:{
            aboutUs(index,type){
               $("html,body").animate({
                   scrollTop:($(type).offset().top-60 )+'px'
               },{
                   duration:500,
                   easing:"swing"
               });

                // $('#ulNode li').each(function(){
                //     $(this).removeClass('active')
                // })
                // $('#ulNode li').eq(index).addClass('active')

               return false

            },
            //这个滚动和导航 对应暂时写死
            handleScroll(){

                var scrollTop = $(document).scrollTop();  //滚动条到顶部垂直的高度

                // console.log(scrollTop,$(document).height()-$(window).height());

                $('#ulNode li').each(function(){
                    $(this).removeClass('active')
                })
                if((scrollTop >= ($(this.menuScrollId[0]).offset().top-65)) && (scrollTop < ($(this.menuScrollId[1]).offset().top-65)) ){
                    $('#ulNode li').eq(0).addClass('active')
                }else if((scrollTop >= ($(this.menuScrollId[1]).offset().top-65)) && (scrollTop < ($(this.menuScrollId[2]).offset().top-65))){
                    $('#ulNode li').eq(1).addClass('active')
                }else if((scrollTop >= ($(this.menuScrollId[2]).offset().top-65)) && (scrollTop < $(document).height()-$(window).height()-5) ){
                    $('#ulNode li').eq(2).addClass('active')
                }else if(scrollTop >= ($(document).height()-$(window).height()-5) ){
                    $('#ulNode li').eq(3).addClass('active')
                }

            }
        },

    }



</script>

<style scoped>

</style>